let SCOPE = null;
const TOKEN_KEY = "@loyality-Token";
const USER_KEY = "@loyality-User";
export const LOGIN_PAGE = "/login-admin";
export const LOGIN_PAGE_CUSTOMER = "/login-customer";

export const isAuthenticated = () => {
  //
  if (localStorage.getItem(TOKEN_KEY) !== null) {
    return true;
  }
  SCOPE = null;
  return false;
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};
export const getUser = () => JSON.parse(localStorage.getItem(USER_KEY));
export const login = ({ data, token }) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(data));
};

export const renewLogin = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = (page) => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.href = page;
};

export const getSessionTimeout = () => {
  // Base64 encoded string
  const base64 = getToken().split(".")[1];

  // create a buffer
  const buff = Buffer.from(base64, "base64");

  // decode buffer as UTF-8
  const str = buff.toString("utf-8");

  // print normal string
  const v = JSON.parse(str);

  const now = Date.now().valueOf() / 1000;

  return parseInt(v.exp - now);
};
